import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    assignGiftgiver (data) {
        return httpService.post(
            ApiEndpoints.get('giftgiver_assign', { familyEditionId: data.id }),
            data.data
        );
    },
    removeGiftgiver (data) {
        return httpService.put(
            ApiEndpoints.get('gifetgiver_remove', { familyEditionId: data.id }),
            data.data
        );
    },
    getGiftgiverCreators () {
        return httpService.get(ApiEndpoints.get('giftgiver_categories'));
    },
    editGiftgiver (data) {
        return httpService.put(
            ApiEndpoints.get('giftgiver_edit', { familyEditionId: data.id }),
            data.data
        );
    },
    resendMail (id) {
        return httpService.post(
            ApiEndpoints.get('resend_gift_giver_notification', { familyEditionId: id })
        );
    },
    resendGiftGivingReportMail (id) {
        return httpService.post(
            ApiEndpoints.get('resend_gift_giving_report_notification', { familyEditionId: id })
        );
    }
};
